import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Drawer, Radio } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

import { ForEach } from "@components/control-statements";

const events = [
  { type: "CUSTOMER_REGISTER", label: "Cadastro" },
  { type: "FIRST_ORDER", label: "Primeiro pedido" },
];

export const EventSourceForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [eventType, setEventType] = useState(node?.data?.eventType);

  const getFreshNode = () => {
    return {
      ...node,
      data: {
        ...node?.data,
        eventType,
      },
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [eventType]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.EventSource}
    >
      <p className={styles.label}>Selecione o evento</p>
      <ForEach
        items={events}
        render={(o) => {
          return (
            <Radio
              text={o.label}
              checked={eventType}
              value={o.type}
              className={"mb-10"}
              onClick={() => setEventType(o.type)}
            />
          );
        }}
      />
      <div className={styles.footer}>
        <Button
          className="w-100"
          design="primary"
          disabled={!eventType}
          onClick={() => eventType && onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
